import * as actionTypes from '../constants/ActionTypes/CarbonSaving';

export const GetCarbonSaving = (UID) => ({
    type: actionTypes.GET_CARBON_SAVING,
    UID
})

export const ResetCarbonSaving = () => ({
    type: actionTypes.RESET_GET_CARBON_SAVING
})
